var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-timeline-content cd-timeline-card--default" },
    [
      _c("div", { staticClass: "cd-timeline-content-text" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.oneLog.text) } }),
        _vm._v(" "),
        _c("span", { staticClass: "nowrap gray-60 fs-2" }, [
          _vm._v(
            _vm._s(
              _vm._f("dateFormatter")(
                _vm.oneLog.timestamp,
                "NORMAL_DATE_TIME",
                true
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _vm.oneLog.linked.length > 0
        ? _c("div", { staticClass: "cd-timeline-links" }, [
            _c("p", [_vm._v(_vm._s(_vm.$l10n.__("Associé à")))]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.oneLog.linked, function(link, key) {
                return _c("li", { key: key }, [
                  _c("i", { class: _vm.getIconByType(_vm.oneLog.objecttype) }),
                  _vm._v(" "),
                  _c("span", { domProps: { innerHTML: _vm._s(link.html) } })
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }